export const MILLISECONDS_PER_HOUR = 36e5
export const INTERVALS_PER_HOUR = 4
const MILLISECONDS_PER_INTERVAL = MILLISECONDS_PER_HOUR / INTERVALS_PER_HOUR

export function intervalDifference(start: Date, end: Date) {
  return Math.round(Math.abs(end.getTime() - start.getTime()) / MILLISECONDS_PER_INTERVAL)
}

export function addInterval(date: Date, interval: number) {
  return new Date(date.getTime() + interval * MILLISECONDS_PER_INTERVAL)
}

export function percentageOfElapsedTime(startDate: Date, endDate: Date, dateOfElapsedTime: Date) {
  const timeSpanOfInterval = endDate.getTime() - startDate.getTime()
  const timeSpanOfElapsedTime = dateOfElapsedTime.getTime() - startDate.getTime()
  return Math.round((timeSpanOfElapsedTime / timeSpanOfInterval) * 100)
}

export type IntervalType = {
  start: number
  end: number
}
export function detectOverlap(i1: IntervalType, i2: IntervalType): boolean {
  // This function is trying to detect if two given intervals in array form {start, end}
  // is overlapping or not
  const maxNum = Math.max(i1.end, i2.end)
  const minNum = Math.min(i1.start, i2.start)

  // Theoretical range to fit the two intervals
  // If the width of the two intervals is less than this range (maxNum - minNum), the two are not overlapping
  // If the width of the two intervals is same as this range, the two touching but not overlapping
  // If the width of the two intervals is greater than this range, the two are overlapping

  const range = maxNum - minNum
  return i1.end - i1.start + (i2.end - i2.start) > range
}
